import Cookies from 'js-cookie';

export const getEmailSubsribe = () => !!Cookies.get('email_subscribe');
